<template>
  <div class="auth-page">
    <!-- 顶部标题 -->
    <div class="header">
      <h1>身份认证</h1>
    </div>

    <!-- 人像扫描区域 -->
    <div class="profile-scan">
      <div class="scan-frame">
        <img src="@/assets/images/faceRecognition.png" alt="" class="profile-img" />
        <div class="scan-line"></div>
      </div>
    </div>

    <!-- 信息表单 -->
    <div class="form-container">
      <el-form
        ref="form"
        :model="form"
        label-position="top"
        :rules="{
          certName: [{ message: '请输入姓名', required: true }],
          certNo: [{ message: '请输入身份证号', required: true }],
        }"
      >
        <el-form-item prop="certName" label="姓名">
          <el-input
            v-model="form.certName"
            style="width: 100%"
            placeholder=""
          />
        </el-form-item>
        <el-form-item prop="certNo" label="身份证号">
          <el-input v-model="form.certNo" style="width: 100%" placeholder="" />
        </el-form-item>
      </el-form>

      <el-button
        type="primary"
        style="width: 100%"
        @click="submitForm"
        :loading="submitBtn_loading"
        >确&nbsp;定</el-button
      >
    </div>
  </div>
</template>

<script>
import { apiAuthFace } from "@/api/open/auth";

export default {
  name: "IdentityAuthentication",
  data() {
    return {
      submitBtn_loading: false,
      form: {
        certName: "",
        certNo: "",
      },
    };
  },
  methods: {
    async submitForm() {
      const isValidate = await this.$refs.form.validate().catch(() => false);
      if (isValidate) {
        this.submitBtn_loading = true;
        const res = await apiAuthFace(this.form);
        if (res.code === 200) {
          if (/^https?:\/\//i.test(res.data || '')) {
            const callPhone = res.data;
            const a = document.createElement("a");
            a.href = callPhone;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(callPhone);
          } else {
            this.$message.warning(res.message);
          }
        } else {
          this.$message.error(res.message);
        }
        this.submitBtn_loading = false;
      }
    },
  },
};
</script>

<style scoped>
.auth-page {
  max-width: 450px;
  margin: 0 auto;
  padding: 20px;
  min-height: 100vh;
}

.header {
  text-align: center;
  padding: 15px 0 30px;
}

.header h1 {
  font-size: 24px;
  font-weight: bold;
  color: #2c3e50;
  letter-spacing: 1px;
}

/* 人像扫描区域 */
.profile-scan {
  display: flex;
  justify-content: center;
  margin-bottom: 35px;
}

.scan-frame {
  width: 230px;
  height: 230px;
  position: relative;
  border: 3px solid #409eff;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(64, 158, 255, 0.4);
  overflow: hidden;
}

.profile-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

.scan-line {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 10px;
  background: rgba(64, 158, 255, 0.6);
  box-shadow: 0 0 15px #409eff;
  animation: scan 2.5s linear infinite;
}

@keyframes scan {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(230px);
  }
}

/* 表单区域 */
.form-container {
  padding: 0 15px;
}

/* 响应式调整 */
@media (max-width: 480px) {
  .auth-page {
    padding: 15px;
  }

  .scan-frame {
    width: 200px;
    height: 200px;
  }

  @keyframes scan {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(200px);
    }
  }

  .header {
    padding: 10px 0 20px;
  }
}
</style>